import { HubConnectionBuilder } from '@microsoft/signalr';
import { SetSignalR } from '../redux/actions/PushNotificationActions';
import * as types from "../redux/constants";
import store from '../redux/store';
// action for user authentication and receiving the access_token
let connection: any = null;



function CheckIfValidCredinations(getState: any) {
    if (!getState()
        || !getState().auth
        || !getState().auth.isAuth
        || !getState().auth.UserData)
        return {
            error: true,
            isAdmin: false
        }
    return {
        error: getState().auth.UserData.isAdmin ? (getState().auth.AdminData === undefined || getState().auth.AdminData === null) : (getState().auth.ClientData === undefined || getState().auth.ClientData === null),
        isAdmin: getState().auth.UserData.isAdmin
    }
}
const signalRMiddleware = ({ getState }: any) => (next: any) => async (action: any) => {
    if (action && action.type === types.AUTH_LOGIN) {
        next(action)
        let _CheckIfValidCredinations = CheckIfValidCredinations(getState);
        ConnectToSignalR(_CheckIfValidCredinations, getState);
    }
    if (action && action.type === types.AUTH_LOGOUT) {
        if (connection) {
            connection.stop();
        }
        connection = null;
    }
    if (action && action.type === types.CHECK_SIGNALR) {
        let _CheckIfValidCredinations = CheckIfValidCredinations(getState);
        if (!_CheckIfValidCredinations.error) {
            if (connection && connection.connectionState === "Disconnected")
                startConnection();
            else if (!connection) {
                ConnectToSignalR(_CheckIfValidCredinations, getState);
            }
        }
        else {
            if (connection)
                connection.stop();
            connection = null;
        }
    }
    return next(action);
};

export default signalRMiddleware;

function ConnectToSignalR(_CheckIfValidCredinations: { error: boolean; isAdmin: any; }, getState: any) {
    if (!_CheckIfValidCredinations.error && _CheckIfValidCredinations.isAdmin) {
        let _email = !_CheckIfValidCredinations.error ? getState().auth.AdminData.Email : "";
        CreateConnection(getState().auth.AdminData, getState().auth.CompanyData.CompanyName, getState().auth.UserData.id, _email, _CheckIfValidCredinations);
        startConnection();
    }
    else if (!_CheckIfValidCredinations.error && !_CheckIfValidCredinations.isAdmin) {
        let _email = !_CheckIfValidCredinations.error ? getState().auth.ClientData.Email : "";
        CreateConnection(getState().auth.ClientData, getState().auth.CompanyData.CompanyName, getState().auth.UserData.id, _email, _CheckIfValidCredinations);
        startConnection();
    }
}

function CreateConnection(adminData: types.GetAdminData, companyName: string, userId: string, email: string, checkIfValidCredinations: any) {
    let _connectionHub = store.getState() && store.getState().CompanyData && store.getState().CompanyData.SignalRHubURL ? store.getState().CompanyData.SignalRHubURL : "";
    connection = new HubConnectionBuilder()
        .withUrl(`${_connectionHub}session?groupName=${companyName}&userId=${userId}&email=${email}&isAdmin=${false}`)
        // .withAutomaticReconnect()
        .build();
}

function startConnection() {
    connection.start()
        .then(() => {
            store.dispatch(SetSignalR(true));
            //store.dispatch(AddSignalr(connection));
            //console.log('call addToGroup');
        }).catch((e: any) => console.log(e));
}
